<template>
  <div class="shipment-tag-wrapper shipment-tag-jet-smartlabel">
    <div class="shipment-root">
      <div class="flex border-b border-black">
        <div class="tag-content">
          <div class="flex justify-center py-4 border-b bg-black border-black text-white print-color-adjust">
            <img :src="shippingCompanyIcon" class="jet-logo" alt="jet-express">
          </div>
        </div>

        <div class="tag-content tag-content--aside flex items-center justify-center border-l border-black">
          <p class="text-protocol mx-1">
            {{ $parent.tag.protocol }}
          </p>
        </div>
      </div>

      <div class="border-b border-black">
        <h2 class="text-center">{{ sortingCode }}</h2>
      </div>

      <div class="border-b border-black">
        <h3 class="text-center">{{ capitalize($parent.tag.to.city) }}</h3>
      </div>

      <div class="flex border-b border-black">
        <div class="tag-content">
          <strong class="py-1 bg-black type-text text-white print-color-adjust">DESTINATÁRIO</strong>

          <div class="px-4 pt-3">
            <p>
              {{ capitalize($parent.tag.to.name) }}
            </p>

            <p v-if="$parent.tag.to.phone.length">
              Tel: {{ maskPhone($parent.tag.to.phone) }}
            </p>

            <p>
              {{ capitalize($parent.tag.to.address) }}<template v-if="$parent.tag.to.locationNumber.length">, </template>
              {{ $parent.tag.to.locationNumber }}
            </p>

            <p>
              {{ capitalize($parent.tag.to.complement) }}<template v-if="$parent.tag.to.complement.length">, </template>
              {{ capitalize($parent.tag.to.district) }}
            </p>

            <p>
              {{ beautifyPostalCode($parent.tag.to.postalCode) }}
              {{ capitalize($parent.tag.to.city) }}<template v-if="$parent.tag.to.stateAbbr.length">/</template>{{ $parent.tag.to.stateAbbr }}
            </p>

            <p v-if="$parent.tag.to.note">
              Obs: {{ $parent.tag.to.note }}
            </p>
          </div>
        </div>

        <div class="tag-content tag-content--aside flex flex-col border-l border-black">
          <div class="flex items-center justify-center">
            <canvas class="melhor-ponto-code my-2"></canvas>
          </div>
        </div>
      </div>

      <div class="border-b border-black">
        <div class="py-2 px-4">
          <strong class="pt-4">REMETENTE:</strong>

          <p>
            {{ capitalize($parent.tag.from.name) }}
          </p>

          <p>
            {{ capitalize($parent.tag.from.address) }}<template v-if="$parent.tag.from.locationNumber.length">, </template>
            {{ $parent.tag.from.locationNumber }}
          </p>

          <p>
            {{ capitalize($parent.tag.from.complement) }}<template v-if="$parent.tag.from.complement.length">, </template>
            {{ capitalize($parent.tag.from.district) }}
          </p>

          <p>
            {{ beautifyPostalCode($parent.tag.from.postalCode) }}
            {{ capitalize($parent.tag.from.city) }}<template v-if="$parent.tag.from.stateAbbr.length">/</template>{{ $parent.tag.from.stateAbbr }}
          </p>
        </div>
      </div>

      <div class="px-2 mt-1 border-b border-black">
        <div class="flex flex-col items-center px-10">
          <canvas
            class="barcode"
            :data-value="tracking"
            data-height="60"
            data-margin="0"
            data-displayvalue="false"
          ></canvas>

          <p class="barcode-code">{{ tracking }}</p>
        </div>
      </div>

      <div
        class="flex justify-between px-10"
        :class="footerSpaces"
      >
        <img :src="melhorEnvioIcon" alt="mehor-envio-logo"/>

        <p class="track">VERIFICADO</p>
      </div>
    </div>
  </div>
</template>

<script>
import { beautifyPostalCode } from 'commons/js/formatters/PostalCode';
import { maskPhone } from 'commons/js/formatters/Mask';
import MelhorPontoQrCode from 'commons/js/mixins/melhorPontoQrCode.js';
import { capitalize } from 'commons/js/utils/strings';

export default {
  name: 'jet-shipment-tag',

  mixins: [MelhorPontoQrCode],

  data() {
    return {
      shippingCompanyIcon: '/images/shipment/jet/jet.svg',
      melhorEnvioIcon: '/images/shipment/jet/logo-melhor-envio.svg',
      mpQrCodeSize: 89,
    }
  },

  computed: {
    hasAdditionalInfo: function () {
      return !!(this.$parent.tag && this.$parent.tag.additionalInfo);
    },
    hasVolume: function () {
      return !!this.$parent.volume && !!this.$parent.volume.seqVolume;
    },
    packages: function () {
      if (!this.hasAdditionalInfo || !this.hasVolume) {
        return '001/001';
      }

      return `${this.$parent.volume.seqVolume.toString().padStart(3, '0')}/${this.$parent.tag.additionalInfo.volume.length.toString().padStart(3, '0')}`;
    },
    dimensions: function () {
      if (!this.$parent.tag && !this.$parent.tag.package) return null;

      return `${this.$parent.tag.package.height}x${this.$parent.tag.package.width}x${this.$parent.tag.package.length}`;
    },
    sortingCode: function () {
      if (!this.hasAdditionalInfo || !this.$parent.tag.additionalInfo.sortingCode || !this.$parent.tag.additionalInfo.sortingCode.trim()) {
        return 'XXXX XXX-XX XXX';
      }

      return this.$parent.tag.additionalInfo.sortingCode;
    },
    tracking: function () {
      return this.$parent.tracking || 'MELHOR ENVIO';
    },
    footerSpaces: function () {
      return this.$parent.tag.to.complement && this.$parent.tag.to.note ? 'py-2': 'py-4';
    },
  },

  methods: {
    beautifyPostalCode,
    maskPhone,
    capitalize,
  },

  mounted() {
    BarCode('.barcode').init();
  },
}
</script>

<style lang="stylus" scoped>
.shipment-root
  p
    font-size 11px
    line-height 13px
  strong
    font-weight 700
    font-size 13px
  .type-text
    text-align center
    padding-right 25px
    padding-left 25px
    position relative
    top 5px
  h2
  h3
    margin-top 0
    margin-bottom 0
  h2
    font-size 35px
    font-weight 700
    line-height 40px
    padding-top 4px
    padding-bottom 4px
    letter-spacing 0em
  h3
    font-size 16px
    font-weight 700
    line-height 18px
    padding-top 4px
    padding-bottom 4px
  .jet-logo
    width 110.5px
  .text-protocol
    font-size 9pt
    font-weight 700
    line-height 10px
    white-space nowrap
  .barcode-code
    margin-top 5px
    margin-bottom 7px
    font-size 13.13px
    font-weight 700
    line-height 15px
.tag-content
  flex 1 1 225px
  &--aside
    flex 1 0 115px
.section-from
  p
    font-size 6pt
    line-height 9px
.barcode
  overflow hidden
  max-width 294px
  margin-top 7px
.track
  font-size 11px
  height 13px
  padding 2px 10px 0px 10px
  margin-top 33px
  display flex
  font-weight 700
  border 1px solid #000
</style>
